import { px } from '../utils/styled-system';
export var spacings = [0,
// 0
4,
// 1
8,
// 2
12,
// 3
16,
// 4
24,
// 5
32,
// 6
38,
// 7
64,
// 8
96,
// 9
128,
// 10
192,
// 11
256,
// 12
512 // 13
];

export var spacing = function spacing(index) {
  return index ? px(spacings[index]) : '';
};